import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import {
  OrganizationPredictionsSettingsResponse,
  OrganizationSuggestionsSettingsResponse,
  PatchOrganizationPredictionsSettingsRequest,
  PatchOrganizationSuggestionsSettingsRequest,
} from 'src/queries/organizations/automationSettings/automationSettings.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getOrganizationSuggestionsSettings = async (
  orgId: string,
): Promise<OrganizationSuggestionsSettingsResponse> => {
  return getResponseData(
    axios.get<OrganizationSuggestionsSettingsResponse>(
      `/organizations/${orgId}/suggestions`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getOrganizationPredictionsSettings = async (
  orgId: string,
): Promise<OrganizationPredictionsSettingsResponse> => {
  return getResponseData(
    axios.get<OrganizationPredictionsSettingsResponse>(
      `/organizations/${orgId}/predictions`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const patchOrganizationSuggestionsSettings = async (
  orgId: string,
  request: PatchOrganizationSuggestionsSettingsRequest,
): Promise<OrganizationSuggestionsSettingsResponse> => {
  return getResponseData(
    axios.patch<OrganizationSuggestionsSettingsResponse>(
      `/organizations/${orgId}/suggestions`,
      request,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const patchOrganizationPredictionsSettings = async (
  orgId: string,
  request: PatchOrganizationPredictionsSettingsRequest,
): Promise<OrganizationPredictionsSettingsResponse> => {
  return getResponseData(
    axios.patch<OrganizationPredictionsSettingsResponse>(
      `/organizations/${orgId}/predictions`,
      request,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
